import { isSupported } from 'firebase/messaging';

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';

import Loading from 'components/global/Loading';

import useAppTracking from 'hooks/useAppTracking';

import axios, { setAuthorizationToken } from 'services/axios';
import { AUTH } from 'services/consts';
import { deleteFCMToken } from 'services/firebase';

import AppLogger from 'utils/AppLogger';
import { logout } from 'utils/configureStore';
import PATHS from 'utils/paths';

const Logout = () => {
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const { reset } = useAppTracking();

	const handleLogout = async () => {
		try {
			await axios.post(AUTH.LOGOUT);
		} catch {
			// do nothing
		}

		try {
			await isSupported().then(async (isSupported) => {
				isSupported && (await deleteFCMToken());
			});
		} catch {
			// do nothing
		}

		setAuthorizationToken();
		reset();
		dispatch(logout())
			.unwrap()
			.then(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		try {
			handleLogout();
		} catch (error) {
			AppLogger.error(error);
			setLoading(false);
		}
	}, []);

	return loading ? <Loading /> : <Navigate to={PATHS.BASE} replace />;
};

export default Logout;
